export default "__VITE_ASSET__c6c98db7__"